import locale from 'date-fns/locale/zh-CN';
export default locale;